// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContactClaimsTeamInfoDto
 */
export interface IContactClaimsTeamInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IContactClaimsTeamInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContactClaimsTeamInfoDto
     */
    name?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof IContactClaimsTeamInfoDto
     */
    allowed_services?: Array<number>;
}

/**
 * Check if a given object implements the IContactClaimsTeamInfoDto interface.
 */
export function instanceOfIContactClaimsTeamInfoDto(value: object): value is IContactClaimsTeamInfoDto {
    return true;
}

export function IContactClaimsTeamInfoDtoFromJSON(json: any): IContactClaimsTeamInfoDto {
    return IContactClaimsTeamInfoDtoFromJSONTyped(json, false);
}

export function IContactClaimsTeamInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContactClaimsTeamInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'allowed_services': json['allowed_services'] == null ? undefined : json['allowed_services'],
    };
}

export function IContactClaimsTeamInfoDtoToJSON(json: any): IContactClaimsTeamInfoDto {
    return IContactClaimsTeamInfoDtoToJSONTyped(json, false);
}

export function IContactClaimsTeamInfoDtoToJSONTyped(value?: IContactClaimsTeamInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'allowed_services': value['allowed_services'],
    };
}

